import { createContext, useContext, useEffect, useState } from "react";

/* Estimate cart: priced items for the instant-quotation system.
   Separate from the enquiry quote basket. Persisted per browser session storage
   is avoided on purpose — localStorage keeps items across pages AND reloads. */
const EstimateCtx = createContext(null);
const LS_KEY = "roxy_estimate_cart";

const load = () => {
    try {
        const raw = JSON.parse(localStorage.getItem(LS_KEY)) || [];
        return raw.map((i) => ({ ...i, brand: i.brand || "", key: i.key || `${i.sku}|${i.brand || ""}` }));
    } catch {
        return [];
    }
};

export function EstimateProvider({ children }) {
    const [items, setItems] = useState(load);

    useEffect(() => {
        try {
            localStorage.setItem(LS_KEY, JSON.stringify(items));
        } catch {}
    }, [items]);

    const add = (item, qty, brand = "") =>
        setItems((prev) => {
            const key = `${item.sku}|${brand}`;
            return prev.find((i) => i.key === key)
                ? prev.map((i) => (i.key === key ? { ...i, qty: i.qty + qty } : i))
                : [...prev, { ...item, key, brand, qty }];
        });
    const setQty = (key, qty) =>
        setItems((prev) => prev.map((i) => (i.key === key ? { ...i, qty: Math.max(0, qty) } : i)).filter((i) => i.qty > 0));
    const remove = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
    const clear = () => setItems([]);
    const count = items.length;

    return (
        <EstimateCtx.Provider value={{ items, add, setQty, remove, clear, count }}>
            {children}
        </EstimateCtx.Provider>
    );
}

export const useEstimate = () => useContext(EstimateCtx);

export const lineAmount = (i) => Math.round(i.flat_price * i.qty * 100) / 100;
export const estimateTotals = (items) => {
    const subtotal = Math.round(items.reduce((s, i) => s + lineAmount(i), 0) * 100) / 100;
    const gst = Math.round(items.reduce((s, i) => s + (i.flat_price * i.qty * (i.gst_percent ?? 18)) / 100, 0) * 100) / 100;
    return { subtotal, gst, total: Math.round((subtotal + gst) * 100) / 100 };
};
